import type { FullSource } from '@/types/source';
import { stripFileExtension } from '@/utils/file-name';

type SourceWithoutDisplayName = Omit<FullSource, 'displayName'> & {
    displayName?: string;
};

export const enrichSource = (source: SourceWithoutDisplayName): FullSource => ({
    ...source,
    displayName: source.displayName ?? stripFileExtension(source.name),
});

export const enrichSources = (
    sources: SourceWithoutDisplayName[],
): FullSource[] => sources.map(enrichSource);

const HDMI_VIEWPORT_PREFIX = 'viewport_';

export function isHdmiViewport(sourceId: string): boolean {
    return sourceId.startsWith(HDMI_VIEWPORT_PREFIX);
}
